import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { ChartsRunService } from './charts.run';

@NgModule({
    providers: [
        provideAppInitializer(() => {
            const initializerFn = ((chartsRunService: ChartsRunService) => () => chartsRunService.initializeApp())(inject(ChartsRunService));
            return initializerFn();
        }),
    ],
})
export class ChartsModule {}
